import Client from 'fhir-kit-client';
import http from "./http-common";
import bundleDataTemplate from './bundle-message-example.json';
import { uuid } from 'vue-uuid';
import _ from 'lodash';
import errorList from './errorList.json';
import { mock_donor_and_recipient_EOC } from '../../data/mocks'
import axios from 'axios'
import { PATIENT_TYPES } from '../constants'
class DataService {

  getPatientDetails() {
    const baseUrl = sessionStorage.getItem( 'baseUrl' );
    const patientId = sessionStorage.getItem( 'patientID' );
    const access_token = sessionStorage.getItem( 'token' );

    const client = new Client( { baseUrl } );
    client.bearerToken = access_token;
    return client.read( { resourceType: 'Patient', id: patientId } );
  }

  searchFHIRClient( data ) {
    const baseUrl = sessionStorage.getItem( 'baseUrl' );
    const patientId = sessionStorage.getItem( 'patientID' );
    const access_token = sessionStorage.getItem( 'token' );


    if ( data.operationType === "Read" ) {
      const client = new Client( { baseUrl } );
      client.bearerToken = access_token;
      return client.read( { resourceType: data.resourceType, id: patientId } );
    }
    if ( data.operationType === "Search" ) {
      const client = new Client( { baseUrl } );
      client.bearerToken = access_token;
      return client.search( {
        resourceType: data.resourceType,
        searchParams: data.searchParams
      } );
    }
  }


  setSessionAttributes( token, patientID, baseUrl, bearerToken, sourceQueries ) {
    sessionStorage.setItem( "token", token );
    sessionStorage.setItem( "patientID", patientID );
    sessionStorage.setItem( "baseUrl", baseUrl );
    sessionStorage.setItem( "bearerToken", bearerToken );
    sessionStorage.setItem( "sourceQueries", sourceQueries );
  }


  prepareBundleData( data ) { 
    const bundleData = structuredClone( bundleDataTemplate );
    bundleData.timestamp = new Date().toString();
    bundleData.id = uuid.v4();
    bundleData.entry[0].resource.id = uuid.v4();
    bundleData.entry[0].fullUrl = "urn:uuid:" + bundleData.entry[0].resource.id;
    bundleData.entry[0].resource.source.endpoint = sessionStorage.getItem( 'baseUrl' ) + "/";
    bundleData.entry[0].resource.focus = [ { reference: `Patient/${data.patient.id}` } ];
    bundleData.entry[1].resource = data.patient;
    
    if ( bundleData.entry.length > 2 ) {
      bundleData.entry.splice( 2, bundleData.entry.length - 2 );
    }
    // If the patient is a donor, then we need to add a '.donor' on the code [TPGLI-8669]
    if( data.patientType === PATIENT_TYPES.DONOR.name ){
      bundleData.entry[0].resource.eventCoding.code += '.donor';
    }
    if ( data.entries ) {
      for ( const entry of data.entries ) {
        for ( const item of entry ) {
          bundleData.entry.push( item )
        }

      }
    }
    return bundleData;
  }
  postPatientData( data, potentialDuplicateConfirmed = false ) {
    const bundleData = this.prepareBundleData( data );
    const bearerToken = sessionStorage.getItem( 'bearerToken' );
    const params = {}
    params.sections = JSON.stringify( data.sectionsChecked );
    //if potential duplicate is confirmed, add the parameter to the request
    if ( potentialDuplicateConfirmed ) {
      params.potential_duplicate_profile_confirmed = true;
    }
    // If episode_id was found in the data then add that to the params.
    if( data.episode_id ){
      params.episode_id = data.episode_id
    }
    return http.post( `/fhir_ingestion`, {
      ...bundleData
    }, {
      'headers': { 'Authorization': `Bearer ${bearerToken}` },
      params
    } )
  }

  getSourceQueries( patientID, bearerToken ) {

    return http.get( `/fhir_ingestion/source_queries/` + patientID, {
      headers: { 'Authorization': `Bearer ${bearerToken}` }
    } )
  }
  async getEpisodesOfCare( patientId, isMockData ) {
    try {
      if ( !patientId ) {
        // Need patient id, TODO: add alert or something...
        console.error( 'Patient id is required to be passed down for episode of care.' )
        return
      }
      // If mock data is turned on then fetch mock data instead of from fhir
      if ( isMockData ) {
        return mock_donor_and_recipient_EOC
      }
      const bearerToken = sessionStorage.getItem( 'token' )
      const sourceQueriesString = sessionStorage.getItem( 'sourceQueries' )
      if ( !sourceQueriesString ) {
        throw new Error( "Cached source query not found." )
      }
      const sourceQueries = JSON.parse( sourceQueriesString )
      // Find the episode of care fetching url in the queries where the resource type is episode of care and the operationType is Search.
      const episodes_endpoint = sourceQueries.queries.find( ( query ) => query.resourceType === 'EpisodeOfCare' && query.operationType === "Search" )
      if ( !episodes_endpoint ) {
        throw "Episodes of care url not found."  
      }
      // Use endpoint to fetch.
      const response = await axios.get( episodes_endpoint.url, {
        headers: { Authorization: `Bearer ${bearerToken}` },
        params: episodes_endpoint.searchParams
      } )
      if ( response ) {
        if ( response.data.total === 0 ) {
          throw "No Episodes of care found for patient." 
        }
        return response.data

      }
      throw response
    }
    catch ( err ) {
     return err
    }

  }
  authorizeState( stateID ) {
    return new Promise( ( resolve, reject ) => {
      http.get( `/auth/states/` + stateID ).then( ( ( response ) => {
        const emr_launch = response.data.authorizations.filter( ( object ) => object._type === "emr_launch" );
        const connect_api = response.data.authorizations.filter( ( object ) => object._type === "connect_api" );
        if ( !_.get( response, 'data.baseUrl' ) || !_.get( emr_launch[0], 'patient' ) || !_.get( connect_api[0], 'access_token' ) ) {
          reject( 'Invalid response received from server' );
        }
        //TODO: add this back when sending to oats.
        this.getSourceQueries( emr_launch[0].patient, connect_api[0].access_token ).then( ( res ) => {
          if ( !_.get( response, 'data' ) ) {
            reject( 'Invalid response received from server' );
          }
          this.setSessionAttributes( emr_launch[0].access_token,
            emr_launch[0].patient, response.data.baseUrl, connect_api[0].access_token, JSON.stringify( res.data ) );
          resolve( 'resolved ' );
        } )
          .catch( ( e ) => {
            reject( e );
          } );

      } ) )
        .catch( ( e ) => {
          reject( e );
        } );
    } )
  }

  getErrorMessage( code ) {
    const errorMessage = errorList[code];
    return errorMessage;
  }


}

export default new DataService();
